import { render, staticRenderFns } from "./SideNav.vue?vue&type=template&id=3522bfa9&scoped=true&"
import script from "./SideNav.vue?vue&type=script&lang=js&"
export * from "./SideNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3522bfa9",
  null
  
)

export default component.exports